export const INK_LUMA_MAX = 230;

type CanvasLike = {
  width?: number;
  height?: number;
  getContext?: (contextId: "2d") => {
    getImageData: (
      sx: number,
      sy: number,
      sw: number,
      sh: number
    ) => { data: Uint8ClampedArray };
  } | null;
};

type SignaturePadLike = {
  isEmpty?: () => boolean;
} | null;

export const canvasHasInk = (canvas?: CanvasLike | null): boolean => {
  if (!canvas || !canvas.width || !canvas.height) {
    return false;
  }

  const ctx = canvas.getContext?.("2d");
  if (!ctx) {
    return false;
  }

  let data: Uint8ClampedArray;
  try {
    data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  } catch {
    return false;
  }

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];
    if (alpha >= 10) {
      const luma = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
      if (luma < INK_LUMA_MAX) {
        return true;
      }
    }
  }

  return false;
};

export const shouldSkipCanvasResize = (
  signatureBase64: string | null,
  signaturePad: SignaturePadLike
): boolean =>
  signatureBase64 === null &&
  Boolean(signaturePad) &&
  typeof signaturePad?.isEmpty === "function" &&
  !signaturePad.isEmpty();

export const signatureDataUrlHasInk = (dataUrl: string): Promise<boolean> =>
  new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(false);
        return;
      }
      ctx.drawImage(image, 0, 0);
      resolve(canvasHasInk(canvas));
    };
    image.onerror = () => resolve(false);
    image.src = dataUrl;
  });
